import {createReducer} from "@reduxjs/toolkit";

const initialState = {
    byId: {},
    allIds: []
};

export default createReducer(initialState, {
    // [requestData]:
});